import { render, staticRenderFns } from "./RemoveCardModal.vue?vue&type=template&id=3ff520c8&scoped=true&"
import script from "./RemoveCardModal.vue?vue&type=script&lang=js&"
export * from "./RemoveCardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff520c8",
  null
  
)

export default component.exports